import actionTypes from './actionType';
import { apiRegister, apiLogin } from '../../services/auth';
export const register = (payload) => async (dispatch) => {
    try {
        const response = await apiRegister(payload)
        if (response?.data.err === 0) {
            dispatch({
                type: actionTypes.REGISTER_SUCCESS,
                data: response.data.token
            })
        } else {
            dispatch({
                type: actionTypes.REGISTER_FAIL,
                data: response.data.msg
            })
        }
    } catch (error) {
        dispatch({
            type: actionTypes.REGISTER_FAIL,
            data: null
        })
    }
}

export const login = (payload) => async (dispatch) => {
    try {
        const response = await apiLogin(payload)
        if (response?.data.err === 0) {
            dispatch({
                type: actionTypes.LOGIN_SUCCESS,
                data: response.data.token
            })
        } else {
            dispatch({
                type: actionTypes.LOGIN_FAIL,
                data: response.data.msg
            })
        }
    } catch (error) {
        dispatch({
            type: actionTypes.LOGIN_FAIL,
            data: null
        })
    }
}
export const logout = () => ({
    type: actionTypes.LOGOUT
})
// bt các action sẽ trả về một obj , nhưng khi cài redux-thunk và sử dụng trong file redux.js (applyMiddleware(thunk)) thì có thể  trả về một hàm từ một hành động Redux thay vì trả về một đối tượng thông thường. Điều này có lợi ích lớn khi bạn cần thực hiện các yêu cầu mạng AJAX, gọi API, hoặc thực hiện các tác vụ bất đồng bộ khác trong quá trình xử lý hành động.